import React, { useEffect, useRef, useState } from "react";
import { Select } from "antd";
import { searchService } from "@/api/home";
import styles from "./style.module.less";
import ImgComps from "../ImgComps";
import Empty from "../empty";
const { Option } = Select;
let timeout: ReturnType<typeof setTimeout> | null;
let currentValue: string;

const fetch = (value: string, callback: (data: { value: string; text: string }[]) => void) => {
  if (timeout) {
    clearTimeout(timeout);
    timeout = null;
  }
  currentValue = value;

  const fake = () => {
    searchService({
      keyword: value
    }).then((d: any) => {
      if (currentValue === value) {
        const { serviceList } = d;
        // const data = serviceList.map((item: any) => ({
        //   value: item.id,
        //   text: item.applicationName
        // }));
        callback(serviceList);
      }
    });
  };
  if (value) {
    timeout = setTimeout(fake, 300);
  } else {
    return callback([]);
  }
};

const SearchInput: React.FC<{
  placeholder: string;
  style?: React.CSSProperties;
  onAppOrLinkClick: Function;
}> = (props) => {
  const { onAppOrLinkClick } = props;
  const [data, setData] = useState<any[]>([]);
  const [value, setValue] = useState<string | undefined>(undefined);
  const selectRef = useRef<any>(null);
  const handleSearch = (newValue: string) => {
    // console.log("handleSearch", newValue);
    fetch(newValue, setData);
  };

  const handleKeyDown = (e: any) => {
    if (e.key === "Enter") {
      e.preventDefault(); // 阻止默认行为
      e.stopPropagation();
      e.nativeEvent?.preventDefault(); // 阻止默认行为
      e.nativeEvent?.stopPropagation();
    }
  };

  useEffect(() => {
    document
      .getElementsByClassName("ant-select-selection-search-input")?.[0]
      ?.removeEventListener("keydown", handleKeyDown);
    // selectRef.current?.removeEventListener("keydown", handleKeyDown);
  }, []);
  return (
    <Select
      showSearch
      value={value}
      placeholder={props.placeholder}
      style={props.style}
      defaultActiveFirstOption={true}
      suffixIcon={null}
      filterOption={false}
      onSearch={handleSearch}
      //   onChange={handleChange}
      //   notFoundContent={<div>无数据</div>}
      notFoundContent={<Empty />}
      allowClear
      className={styles.wraper}
      dropdownClassName={styles.dropdown_wraper}
      // onSelect={onSelect}
      ref={(ref) => {
        selectRef.current = ref;
        document
          .getElementsByClassName("ant-select-selection-search-input")?.[0]
          ?.addEventListener("keydown", handleKeyDown);
      }}
      // onKeyDown={handleKeyDown}
    >
      {data.map((item: any, index: number) => {
        return (
          <Option key={item.id} value={item.applicationName} disabled={item.serviceType !== 1}>
            <div
              className={styles["select-item"]}
              onClick={(e) => {
                if (item.serviceType !== 1) return;
                selectRef.current?.blur?.();
                e.stopPropagation();
                e.nativeEvent?.preventDefault(); // 阻止默认行为
                e.nativeEvent?.stopPropagation();
                setTimeout(() => {
                  onAppOrLinkClick({ ...item, urlType: 2 });
                }, 20);
              }}
            >
              <ImgComps className={styles.icon} src={item.serviceIconUrl} />
              <div className={styles.name}>{item.applicationName}</div>
            </div>
          </Option>
        );
      })}
    </Select>
  );
};
export default SearchInput;
